/**
 * Subimods Support Showroom — hero carousel + gallery lightbox
 * Root: [data-sm-support-showcase]
 * Docs: SM-SUPPORT-PAGES.md §27
 */
(function () {
  'use strict';

  var ROOT_SEL = '[data-sm-support-showcase]';
  var REDUCE_MQ = '(prefers-reduced-motion: reduce)';
  var INTERVAL = 6500;

  function initRoot(root) {
    if (!root || root.dataset.smShowcaseReady === '1') return;
    root.dataset.smShowcaseReady = '1';
    initHero(root);
    initLightbox(root);
  }

  function initHero(root) {
    var hero = root.querySelector('[data-sm-showcase-hero]');
    if (!hero) return;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-sm-showcase-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-sm-showcase-dot]'));
    var prevBtn = hero.querySelector('[data-sm-showcase-prev]');
    var nextBtn = hero.querySelector('[data-sm-showcase-next]');
    if (slides.length < 2) return;

    var reduceMotion = window.matchMedia(REDUCE_MQ).matches;
    var index = 0;
    var timer = null;
    var touchStartX = null;

    function goTo(next) {
      var n = slides.length;
      index = ((next % n) + n) % n;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function next() {
      goTo(index + 1);
    }

    function start() {
      stop();
      if (reduceMotion) return;
      timer = window.setInterval(next, INTERVAL);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(index - 1);
        start();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(index + 1);
        start();
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.getAttribute('data-index') || 0));
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;
      touchStartX = event.changedTouches[0].clientX;
      stop();
    }, { passive: true });
    hero.addEventListener('touchend', function (event) {
      if (touchStartX == null || !event.changedTouches || !event.changedTouches[0]) {
        start();
        return;
      }
      var dx = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
      start();
    }, { passive: true });

    start();
  }

  function initLightbox(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sm-showcase-gallery]'));
    var box = root.querySelector('[data-sm-showcase-lightbox]');
    var img = root.querySelector('[data-sm-showcase-lightbox-image]');
    if (!items.length || !box || !img) return;

    var lastFocus = null;

    function open(src, alt) {
      lastFocus = document.activeElement;
      img.src = src;
      img.alt = alt || 'Subimods showroom';
      box.hidden = false;
      document.documentElement.classList.add('sm-showcase-lightbox-open');
      var closeBtn = box.querySelector('.sm-support-showcase-lightbox__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      box.hidden = true;
      img.removeAttribute('src');
      document.documentElement.classList.remove('sm-showcase-lightbox-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        open(item.getAttribute('data-src'), item.getAttribute('data-alt'));
      });
    });

    box.querySelectorAll('[data-sm-showcase-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !box.hidden) close();
    });
  }

  function boot() {
    document.querySelectorAll(ROOT_SEL).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector(ROOT_SEL) || (event.target.matches && event.target.matches(ROOT_SEL) ? event.target : null);
    if (root) {
      root.dataset.smShowcaseReady = '';
      initRoot(root);
    }
  });
})();
